import { Typography } from '@material-ui/core';
import React from 'react';

export function GraphInfo(props) {
  const showInfo = () => {
    let oldDate = new Date(props.x);
    if (isNaN(oldDate)) {
      return {
        nameStep: props.step,
        x: props.x,
        y: props.y,
      };
    }
    let year = oldDate.getUTCFullYear();
    let month = oldDate.getUTCMonth();
    let day = oldDate.getUTCDate();
    let hours = oldDate.getUTCHours();
    let minutes = oldDate.getUTCMinutes();
    let seconds = oldDate.getUTCSeconds();

    let oldDateX2 = new Date(props.x2);
    let yearX2 = oldDateX2.getUTCFullYear();
    let monthX2 = oldDateX2.getUTCMonth();
    let dayX2 = oldDateX2.getUTCDate();
    let hoursX2 = oldDateX2.getUTCHours();
    let minutesX2 = oldDateX2.getUTCMinutes();
    let secondsX2 = oldDateX2.getUTCSeconds();

    let newDate = new Date(year, month, day, hours, minutes, seconds);
    let newDateX2 = new Date(
      yearX2,
      monthX2,
      dayX2,
      hoursX2,
      minutesX2,
      secondsX2
    );
    return {
      nameStep: props.step,
      x: newDate.toLocaleString([], { hour12: false }),
      x2: newDateX2.toLocaleString([], { hour12: false }),
      y: props.y,
    };
  };

  if (!props.x) {
    return null;
  }

  const { nameStep, x, x2, y } = showInfo();

  return (
    <Typography
      style={{
        fontSize: '13px',
        float: 'left',
        paddingLeft: '5px',
        color: '#66788A',
      }}
    >
      <h3>{y}</h3>
      <h1>{nameStep}</h1>
      <h5>{x} -</h5>
      <h5>{x2}</h5>
    </Typography>
  );
}
